import { gql } from '@apollo/client';

export const IS_LOGINED = gql`
  query checkAccountState {
    checkAccountState {
      isInitial
    }
  }
`;

export const SIGN_IN = gql`
  mutation clinicSignIn($input: ClinicSignInInput!) {
    clinicSignIn(input: $input) {
      accessToken
      refreshToken
    }
  }
`;

export const GET_CURRENT = gql`
  query queryClinicMyInfo {
    queryClinicMyInfo {
      id
      identifier
      name
      phone
      serial
    }
  }
`;

export const REQUEST_RESET = gql`
  mutation clinicRequestResetPassword(
    $input: ClinicRequestResetPasswordInput!
  ) {
    clinicRequestResetPassword(input: $input)
  }
`;

export const DETECT_MATCH = gql`
  query clinicDetectPasswordMatch($input: ClinicDetectPasswordMatchInput!) {
    clinicDetectPasswordMatch(input: $input) {
      isNewPasswordDifferentFromPreviousOne
    }
  }
`;

export const RESET_PASSWORD = gql`
  mutation clinicResetPassword($input: ClinicResetPasswordInput!) {
    clinicResetPassword(input: $input)
  }
`;

export const CHANGE_PASSWORD = gql`
  mutation clinicChangePassword($input: ClinicChangePasswordInput!) {
    clinicChangePassword(input: $input)
  }
`;

export const GET_SHORT_TERM_TOKEN = gql`
  query queryShortTermToken {
    queryShortTermToken {
      accessToken
    }
  }
`;
